import { render, staticRenderFns } from "./myInheritorApply.vue?vue&type=template&id=1b85fa80&scoped=true&"
import script from "./myInheritorApply.vue?vue&type=script&lang=js&"
export * from "./myInheritorApply.vue?vue&type=script&lang=js&"
import style0 from "./myInheritorApply.vue?vue&type=style&index=0&id=1b85fa80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85fa80",
  null
  
)

export default component.exports